module.exports = __webpack_public_path__ + "60620e850f30b0da0d89bc25f3d69958.svg";